import { useCoreAPIClient } from "@/api/core/CoreAPIClientProvider";
import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "./queryKeys";

export function useGetTenantEventsByTenantID(
  tenantID: string,
  options?: { enabled?: boolean }
) {
  const client = useCoreAPIClient();

  return useQuery({
    queryKey: queryKeys.tenantEvents(tenantID),
    queryFn: () => client.getTenantEvents(tenantID),
    enabled: options?.enabled,
  });
}
